import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

declare let cordova: any;
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Token': ""
  })
};

@Injectable({ providedIn: 'root' })
export class BaseService implements OnInit {

  apiurl = environment.apiurl;
  constructor(public httpClient: HttpClient) { }
  ngOnInit() { }


  GetHeaders(isformupload: boolean) {
    let _httpOptions;    
    if (isformupload) {
      _httpOptions = { headers: new HttpHeaders({ 'PC_FORM-Type': 'form' }) };
    }
    return _httpOptions;
  }
  // subject = new Subject();
  loginStatus: Subject<any> = new Subject();


  onLoginstatus(): Observable<any> {
    return this.loginStatus.asObservable();
  }

  downloadPDF(url: any, postedData: any): any {
    if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) { url = `${this.apiurl}` + url; }
    return this.httpClient.post(url, postedData, { responseType: 'blob' }).toPromise().then((data: any) => {// .get(url, { responseType: 'blob'})
      return data;//new Blob([data], { type: 'application/pdf', });
    });
  }

  async apiPost(needDeserialize: any, url: any, postedData: any, isformupload: boolean = false): Promise<any> {
    if (this.initcheck()) {
      var result: any;
      if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) { url = `${this.apiurl}` + url; }
      // else if (url.indexOf("https://") == -1) { url=`${this.apiurl}` + url;   }

      //console.log('url :' + url);
      await this.httpClient.post(url, postedData, this.GetHeaders(isformupload)).toPromise().then((data: any) => {
        result = data;
      }).catch((err: HttpErrorResponse) => {
        if (err.status == 400) {
          result = err.error;
        } else if (err.status == 404) {
          result = err.error;
        } else if (err.status == 302) {
          result = err.error;
        }
      });

      if (needDeserialize)
        result = (result != "" ? JSON.parse(result) : result);
      else
        result = result;


      return result;
    } else {
      return "";
    }
  }

  async apiPostServerError(needDeserialize: any, url: any, postedData: any, isformupload: boolean = false): Promise<any> {
    if (this.initcheck()) {
      var result: any;
      if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) { url = `${this.apiurl}` + url; }
      // else if (url.indexOf("https://") == -1) { url=`${this.apiurl}` + url;   }

      //console.log('url :' + url);
      await this.httpClient.post(url, postedData, this.GetHeaders(isformupload)).toPromise().then((data: any) => {
        result = data;
      }).catch((err: HttpErrorResponse) => {
        if (err.status == 400) {
          result = err.error;
        } else if (err.status == 404) {
          result = err.error;
        } else if (err.status == 302) {
          result = err.error;
        }
        else
        {
          result = "Server error";
        }
      });

      if (needDeserialize)
        result = (result != "" ? JSON.parse(result) : result);
      else
        result = result;


      return result;
    } else {
      return "";
    }
  }


  async apiGet(needDeserialize: any, url: any): Promise<any> {
    if (this.initcheck()) {
      var result: any;

      await this.httpClient.get(`${this.apiurl}` + url).toPromise().then((data: any) => {
        result = data;
      }).catch((err: HttpErrorResponse) => {
        if (err.status == 400) {
          result = err.error;
        } else if (err.status == 404) {
          result = err.error;
        }
      });

      if (needDeserialize)
        result = (result != "" ? JSON.parse(result) : result);
      else
        result = result;


      return result;
    } else {
      return "";
    }
  }



  async apiPost_subscribe(needDeserialize: any, url: any, postedData: any, isformupload: boolean = false) {
    if (this.initcheck()) {
      var result: any;
      if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) { url = `${this.apiurl}` + url; }
      // else if (url.indexOf("https://") == -1) { url=`${this.apiurl}` + url;   }
      return await this.httpClient.post(url, postedData, this.GetHeaders(isformupload)).pipe(
       // timeout(5000),
        retry(2),
        catchError(error => {
          let errorMsg: string;
          if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
          } else {
            errorMsg = this.getServerErrorMessage(error);
          }

          return throwError(errorMsg);
        })
      );
    }
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.message}`;
      }

    }
  }

  
  
 apiPost_pipe(needDeserialize: any, url: any, postedData: any, isformupload: boolean = false) {

    if (this.initcheck()) {

      var result: any;

      if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) { url = `${this.apiurl}` + url; }

      // else if (url.indexOf("https://") == -1) { url=`${this.apiurl}` + url;   }

      return  this.httpClient.post(url, postedData, this.GetHeaders(isformupload));

    }

  }

  apiDownload_csv(url: any, postedData: any, reportName:any) {
    
    let ReportName = reportName;

    // const CurrentDate: Date = new Date();
    // const format1 = "DD-MM-YYYY-HH-mm";
    // var FormattedCurrentDate = moment(CurrentDate).format(format1)

    // let ReportType = type;
    // let ReportName = 'MeetingReport';

    // if(ReportType == 'Meeting')
    // {
    //   ReportName = 'MeetingReport-' + FormattedCurrentDate +'.csv'; 
    // }
    // else if(ReportType == 'Travel')
    // {
    //   ReportName = 'TravelReport-' + FormattedCurrentDate +'.csv'; 
    // }
    // else if(ReportType == 'Hospital')
    // {
    //   ReportName = 'HospitalReport-' + FormattedCurrentDate +'.csv'; 
    // }

    return this.httpClient.post(environment.apiurl + url, postedData, { responseType: 'blob' }).toPromise().then(
      async (d: any) => {
        saveAs(d,ReportName)
    })
    }

   apiDownload_excel(url: any, postedData: any, reportName:any) {
    
    let ReportName = reportName;

    
    return this.httpClient.post(environment.apiurl + url, postedData, { responseType: 'blob' ,}).toPromise().then(
      async (d: any) => {
        //saveAs(d,ReportName)
        const blob = new Blob([d], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = ReportName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
    })
    }

  initcheck() {
    return true;
  }

}
